<div class="modal-body" [class.text-center]="roundedButtons" data-testid="confirm-modal">
  <h3 *ngIf="title">{{title | translate}}</h3>
  <div *ngIf="body" class="spacer-md" [innerHTML]="body"></div>

  <div class="text-center khModalButtons" [class.confirm-dialog-actions]="roundedButtons">
    <button
      khA11yActionButton
      [class]="roundedButtons ? 'kh-primary-button' : 'btn btn-primary'"
      (click)="onFirstButtonClick()"
      *ngIf="firstButtonText"
      data-testid="primary-button">{{firstButtonText | translate}}</button>
    <button
      khA11yActionButton
      [class]="roundedButtons ? 'kh-tertiary-button' : 'btn btn-default ml-1'"
      (click)="onSecondButtonClick()"
      *ngIf="secondButtonText"
      data-testid="secondary-button">{{secondButtonText | translate}}</button>
  </div>
</div>
